import { ReactNode } from 'react';

import { Stack, useTheme, useMediaQuery, Divider } from '@mui/material';

interface SplitSettingsWrapperProps {
  children: ReactNode;
}

export default function SplitSettingsWrapper(props: SplitSettingsWrapperProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Stack
      divider={<Divider flexItem orientation={isSmallScreen ? "horizontal" : "vertical"} />}
      spacing={3}
      direction={isSmallScreen ? "column" : "row"}
      sx={{ pt: 2, pr: 2, pl: 2 }}>
      {props.children}
    </Stack>
  )
}